
import { Component, Vue } from 'vue-property-decorator';
import { ActionMethod } from 'vuex';
import { Action } from 'vuex-class';
import Cookies from 'js-cookie';

@Component({
  name: 'Logout',
})
export default class Logout extends Vue {
  created() {
    window.localStorage.removeItem('accessToken')

    Cookies.remove('forceOff');
    Cookies.remove('apiAuthToken');
    Cookies.remove('placeId');

    if (this.$route.redirectedFrom) {
      this.setAuthBack(this.$route.redirectedFrom);
    }

    this.$router.replace({
      name: 'signIn'
    });
  }

  private render() {
    return this.$slots.default;
  }

  @Action('setAuthBack', {
    namespace: 'user'
  })
  setAuthBack!: ActionMethod;
}
